import * as THREE from "three";
import * as cuBuilding from "./building_pricing/pricingReducer";
import * as cuComponent from "./building_component/componentReducer";

import { params, const_var } from "./reducer";
import { calcOverhangSize } from "../../helpers/building_component/buildingComponent.helper";
import { calculateLegsCount } from "../../helpers/common/common.helper";
import {
	GrassBackground,
	GrayBackground,
	GROUND_IMG,
	MetalStripeImg,
	SKY_IMG,
	TrimTexture,
	ReflectLegTexturePX,
	ReflectLegTextureNX,
	ReflectLegTexturePY,
	ReflectLegTextureNY,
	ReflectLegTexturePZ,
	ReflectLegTextureNZ
} from "../../utils/Textures";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { controls } from "./common/eventReducer";
import { LEAN_TYPE_NUM_TO_STR, LEAN_TYPE_STR_TO_NUM } from "../../Constants/constant";
import { overHangCostTypeCalculation } from "../../helpers/extra_options_pricing/extra.pricing.helper";
import { textureAnisotropy } from "../../utils/Functions";
import axios from "axios";
import { getInsulation } from "../../action/building_component/buildingComponent.action";
import { setBuildingSidingMaterialOptions } from "../../helpers/building/building_material/buildingMaterial.helper";
import { calcRoofColorPrice, check_wainscot_color } from "../../helpers/building/building_color/building.color.helper";
import { extractDataFromInsulation } from "../../helpers/insulation_pricing/insulationPricing.helper";
import { findActiveWall } from "../../helpers/building_pricing/wall_pricing/wallPricing.helper";
import { checkleanLegsDataAccordingtoResponse, checkLegsDataAccordingtoResponse, checkReinforcedLeg } from "../../helpers/building_component/legs_condition.helper";

export const PRICE_OF_VALUES = {
	building_amount: "building_amount",
	base_price: "base_price",
	height: "height",
	wall: "wall"
};
export const PRICE_TYPES = {
	PERCENTAGE: "%",
	SQFT: "sqft",
	FT: "ft",
	DOLLAR: "$"
};
export const setExtraOptionsVariables = (const_var) => {
	if (const_var.isLTBuilding) {
		const_var.ExtraItemsFeaturesArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding));
		const_var.ExtraItemsFeaturesQuantityArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray.centerBuilding));
		const_var.extraAddOnItemsArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.extraAddOnItemsArray.centerBuilding));
		const_var.post_data.building.ExtraItemsFeaturesArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding));
		const_var.post_data.building.ExtraItemsFeaturesQuantityArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray.centerBuilding));
		const_var.post_data.building.extraAddOnItemsArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.extraAddOnItemsArray.centerBuilding));
	}
	const_var.post_data.building.ExtraItemsFeaturesArrayForOverhangComputation = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation));
};

export const getBuildingName = (leanType, defaultName) => {
	if (hasGableLeanto(leanType)) {
		return `${capitalize(leanType)} Building`;
	} else {
		if (defaultName) {
			return defaultName;
		} else {
			return `${capitalize(leanType)} Lean-To`;
		}
	}
};

export const replaceLeanWithBuilding = (input, shouldDoubleCheck) => {
	if (!input) {
		return "";
	}
	if (shouldDoubleCheck) {
		const leanType = ["right", "left", "front", "back"].find((dir) => dir === input.trim().split(/\s+/)[0].toLowerCase());
		if (leanType) {
			if (!hasGableLeanto(leanType)) {
				return input;
			}
		}
	}
	return input.replace(/\b(Right|Left|Front|Back)\s+(Leanto|Lean)\b/gi, (match, direction) => {
		return `${direction} Building`;
	});
};

export const addDiscountExclusionsInPayload = (cv) => {
	if (cv.discount_info != undefined && Object.keys(cv.discount_info).length) {
		cv.post_data["building"].discount_info = cv.discount_info;
	}
};

export function testFor26Gauage(str) {
	const regex = /26.*(ga|gauge)/i;
	return regex.test(str);
}

export function hasColoredScrews(str) {
	const regex = /\b(colou?r)\b.*\b(screws?)\b|\b(screws?)\b.*\b(colou?r)\b/i;
	return regex.test(str);
}

export const getPriceToExclude = (post_data, extraItems, exclusionData, commissions) => {
	let priceToExclude = 0;
	let exclusions = undefined;

	if (exclusionData?.exclusions) {
		exclusions = JSON.parse(JSON.stringify(exclusionData?.exclusions));
		exclusions.doors_excluded = exclusions.doors_excluded.map((d) => d.sub_category).flat();
	}
	let currentInsulationId = post_data.building?.insulation_type?.insulation_id || 0;
	let currentInsulationPrice = post_data.building?.insulation_price || 0;
	let checkOrNot = false;
	commissions?.forEach((c) => {
		// clean insulations
		if (c.component == "insulation" && c?.category == currentInsulationId && parseFloat(currentInsulationPrice) >= parseFloat(c.from) && parseFloat(currentInsulationPrice) <= parseFloat(c.to)) {
			const index = exclusions?.insulation_excluded?.findIndex((excludedInsulation) => excludedInsulation == c?.category);
			if (index > -1) {
				checkOrNot = true;
				exclusions.insulation_excluded.splice(index, 1);
			}
		}

		// clean doors
		if (c.component.includes("door")) {
			const index = exclusions?.doors_excluded?.findIndex((excludedDoor) => excludedDoor == c?.sub_category[0]);
			if (index > -1) {
				exclusions.doors_excluded.splice(index, 1);
			}
		}
	});

	if (exclusions) {
		// SIDING
		const_var.selSidingObj = const_var.mainSidingOptions.find((obj) => obj.name == const_var.selSidingOption);
		if (const_var.selSidingObj.price_type === "$") {
			if (exclusions?.siding_excluded?.includes(const_var.selSidingObj.name)) {
				// center bulding
				priceToExclude += parseFloat(post_data.building.back_wall_price);
				priceToExclude += parseFloat(post_data.building.front_wall_price);
				priceToExclude += parseFloat(post_data.building.left_wall_price);
				priceToExclude += parseFloat(post_data.building.right_wall_price);
				priceToExclude += post_data.building?.utility_price ? parseFloat(post_data.building.utility_price) : 0;

				// lean tos
				post_data.building.leanto.forEach((leanto) => {
					priceToExclude += leanto?.front_wall_price ? parseFloat(leanto.back_wall_price) : 0;
					priceToExclude += leanto?.front_wall_price ? parseFloat(leanto.front_wall_price) : 0;
					priceToExclude += leanto?.side_wall_price ? parseFloat(leanto.side_wall_price) : 0;
					priceToExclude += leanto?.utility_price ? parseFloat(leanto.utility_price) : 0;
				});
			}
		}

		if (const_var.selSidingObj.price_type === "%") {
			if (exclusions?.siding_excluded?.includes(const_var.selSidingObj.name)) {
				// center bulding
				priceToExclude += parseFloat(post_data.building.siding_material_price);
				// lean tos
				post_data.building.leanto.forEach((leanto) => {
					priceToExclude += leanto?.side_wall_price ? parseFloat(leanto.side_wall_price) : 0;
				});
			}
		}
		// INSULATION
		if (Array.isArray(exclusions?.insulation_excluded)) {
			// main building insulation
			if (post_data.building?.insulation_type && post_data.building?.insulation_price > 0 && exclusions?.insulation_excluded.includes(post_data.building.insulation_type.insulation_id) && !checkOrNot) {
				priceToExclude += parseFloat(post_data.building.insulation_price);
			}

			// lean to insulation
			post_data.building?.leanto?.forEach((leanto) => {
				if (leanto?.insulation_type && leanto?.insulation_price > 0 && exclusions?.insulation_excluded.includes(leanto.insulation_type.insulation_id) && !checkOrNot) {
					priceToExclude += parseFloat(leanto.insulation_price);
				}
			});
		}

		// DOORS
		const doorsToExclude = exclusions?.doors_excluded;
		if (Array.isArray(doorsToExclude) && doorsToExclude?.length && Array.isArray(const_var.entry_points)) {
			const_var.entry_points.forEach((door) => {
				if (doorsToExclude.find((d) => d === door.nested_array_key && !door.parent_array_key.includes("Frameout"))) {
					priceToExclude += parseFloat(door.overheadDoorSum);
				}
			});
		}
	}

	return parseFloat(priceToExclude);
};

export const getReadableExclusions = (exclusions) => {
	let arr = [];
	let obj1 = {};

	if (exclusions.doors_excluded && Array.isArray(exclusions.doors_excluded) && exclusions.doors_excluded.length) {
		arr = exclusions.doors_excluded.map((obj) => obj.sub_category).flat();
		obj1["doors_excluded"] = exclusions.doors_excluded.map((obj) => obj.sub_category).flat();
	}

	Object.keys(exclusions).map((obj) => {
		// ############################## If insulation excluded, then first check if insulation id exsist or not. If it exsist we find the insulation name then we push that insulation name in array ###########################
		if (obj == "insulation_excluded" && exclusions[obj] && Object.keys(exclusions[obj]).length > 0 && const_var.insulationJson && Object.keys(const_var.insulationJson).length > 0) {
			const a = [];
			exclusions[obj].forEach((item) => {
				if (const_var.insulationJson[item] != undefined) {
					a.push(const_var.insulationJson[item]);
				}
			});
			arr.push(...a);
			obj1["insulation_excluded"] = a;
		}
		// ############################## If siding excluded, we directly push the siding name in array ###########################
		if (obj == "siding_excluded" && exclusions[obj] && exclusions[obj]?.length > 0 && const_var.sidingOptions?.length > 0) {
			const a = [];
			exclusions[obj].forEach((item) => {
				let filterSidingObj = const_var.sidingOptions.find((siding) => siding.value == item);
				if (filterSidingObj != undefined) {
					a.push(filterSidingObj.label);
				}
			});
			arr.push(...a);
			obj1["siding_excluded"] = a;
		}
	});

	return { arr, obj: obj1 };
};

const loader = new THREE.TextureLoader();
const loadTextureAsync = async (url) => {
	return new Promise((resolve, reject) => {
		loader.load(
			`https://cdn.sensei3d.com/watermark/${url}`,
			(texture) => {
				resolve(texture);
			},
			undefined,
			(error) => {
				reject(error);
			}
		);
	});
};

const setDimensions = (widthRatio, heightRatio, manufacturerLogoFront, manufacturerLogoBack, manufacturerLogoCenter, isEagleLogo) => {
	// set dimention for front logo
	manufacturerLogoFront.name = "manufacturerLogoFront";
	if (isEagleLogo) {
		manufacturerLogoFront.scale.set(2.5, 0.9, 4);
		manufacturerLogoFront.position.set(0, params.p_h + ((params.p_w / 2) * (params.p_r_p / 12)) / 2, params.p_d / 2 + 0.3);
		manufacturerLogoFront.rotation.y = 0;
		if (params.singleSlope) {
			manufacturerLogoFront.position.set(params.p_w / 2 + 0.1, params.p_h - 1.5, 0);
			manufacturerLogoFront.rotation.y = Math.PI / 2;
		}
	} else {
		manufacturerLogoFront.scale.set(widthRatio, heightRatio, 4);
		manufacturerLogoFront.position.set(0, params.p_h + ((params.p_w / 2) * (params.p_r_p / 12)) / 1.1 - heightRatio / 2 - (widthRatio / 2) * (params.p_r_p / 12) - 0.2, params.p_d / 2 + 0.3);
		if (params.singleSlope) manufacturerLogoFront.position.y = params.p_h - (params.p_w * (params.p_r_p / 12)) / 2 - heightRatio / 2 - (widthRatio / 2) * (params.p_r_p / 12) - 0.2;
	}
	if (params.p_f_w == "Open" && params.p_u_c == true && (!isEagleLogo || (isEagleLogo && !params.singleSlope))) {
		manufacturerLogoFront.position.z = params.p_d / -2 + Number(params.p_u_t) + Number(params.endStoragePositionZ) + 0.3;
	}

	// set dimention for back logo
	manufacturerLogoBack.scale.set(manufacturerLogoFront.scale.x, manufacturerLogoFront.scale.y, manufacturerLogoFront.scale.z);
	manufacturerLogoBack.position.set(manufacturerLogoFront.position.x, manufacturerLogoFront.position.y, params.p_d / -2 - 0.3);
	manufacturerLogoBack.rotation.set(manufacturerLogoFront.rotation.x, Math.PI, manufacturerLogoFront.rotation.z);

	// set dimention for center logo
	manufacturerLogoCenter.scale.set(manufacturerLogoFront.scale.x + 5, manufacturerLogoFront.scale.y + 5, manufacturerLogoFront.scale.z);
	manufacturerLogoCenter.position.set(0, 0.15, 0);
	manufacturerLogoCenter.rotation.set(Math.PI / -2, 0, 0);
};

export const logoTexture = async () => {
	const isEagleLogo =
		const_var.crmSetting.main_domain_url == "eaglebuildings.com" ||
		const_var.crmSetting.parent_api_token == "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG" ||
		const_var.crmSetting.parent_api_token == "6rvAF8gKOwGgnaXPiq0IpVbvDfqsoCBHwhzD5vfPwJqUROHRSD8QFmzsyI7L6bhw" ||
		const_var.crmSetting.parent_api_token == "cwftpxBRVDibr59RbeluiP79dUKPKtbriLE9r7dIz8BZE3xosRioZhBZrx5LrgNv";

	if (
		const_var.scene != undefined &&
		const_var.scene != "" &&
		const_var.scene.getObjectByName("manufacturerLogoFront") != undefined &&
		const_var.crmSetting.parent_api_token !== undefined &&
		const_var.crmSetting.parent_api_token !== "" &&
		const_var.crmSetting.parent_api_token !== null
	) {
		let widthRatio = params.logoWidth * params.p_w;
		let heightRatio = params.logoHeight * params.p_w;
		let waterMarkLogo = const_var.crmSetting.is_own_watermark != undefined ? const_var.crmSetting.is_own_watermark : const_var.crmSetting.parent_api_token || const_var.crmSetting.api_token;

		let manufacturerLogoFront = const_var.scene.getObjectByName("manufacturerLogoFront");
		let manufacturerLogoBack = const_var.scene.getObjectByName("manufacturerLogoBack");
		let manufacturerLogoCenter = const_var.scene.getObjectByName("manufacturerLogoCenter");

		if (waterMarkLogo != undefined) {
			try {
				let fileURL = `${waterMarkLogo}.svg`;

				setDimensions(widthRatio, heightRatio, manufacturerLogoFront, manufacturerLogoBack, manufacturerLogoCenter, isEagleLogo);
				let eagleInvertTexture;
				let eagleTexture;
				if (isEagleLogo) {
					let eagleInvertImg = `Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG-invert.svg`;
					eagleInvertTexture = await loadTextureAsync(eagleInvertImg);
					eagleInvertTexture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
					eagleInvertTexture.wrapS = THREE.RepeatWrapping;
					eagleInvertTexture.wrapT = THREE.RepeatWrapping;

					let eagleImg = `Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG-eagle.svg`;
					eagleTexture = await loadTextureAsync(eagleImg);
					eagleTexture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
					eagleTexture.wrapS = THREE.RepeatWrapping;
					eagleTexture.wrapT = THREE.RepeatWrapping;
				}

				let texture = await loadTextureAsync(fileURL);

				texture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
				params.logoWidth = texture.image.width / 1000 / 20;
				params.logoHeight = texture.image.height / 1000 / 20;
				manufacturerLogoFront.material.map = isEagleLogo && eagleTexture ? eagleTexture : texture;
				if (isEagleLogo) {
					manufacturerLogoFront.material.displacementMap = eagleInvertTexture;
					manufacturerLogoFront.material.displacementScale = 0.05;
					manufacturerLogoFront.material.color.setHex("0x707070");
				}
				manufacturerLogoFront.renderOrder = new Date().getTime() + 3600 * 24 * 5000;
				manufacturerLogoFront.material.map.wrapS = THREE.RepeatWrapping;
				manufacturerLogoFront.material.map.wrapT = THREE.RepeatWrapping;
				manufacturerLogoFront.material.transparent = true;
				manufacturerLogoFront.material.opacity = 1;
				manufacturerLogoFront.material.needsUpdate = true;
				manufacturerLogoFront.visible = !isEagleLogo
					? (params.p_f_w == "Close" || (params.p_f_w == "Open" && params.p_u_c == true)) && manufacturerLogoFront.material.map != null && manufacturerLogoFront.material.map != undefined
						? true
						: false
					: (params.p_f_w != "Open" || (params.p_f_w == "Open" && params.p_u_c == true)) &&
						  params.singleSlope == false &&
						  manufacturerLogoFront.material.map != null &&
						  manufacturerLogoFront.material.map != undefined
						? true
						: params.p_r_w != "Open" && params.singleSlope == true
							? true
							: false;

				widthRatio = params.logoWidth * params.p_w;
				heightRatio = params.logoHeight * params.p_w;
				setDimensions(widthRatio, heightRatio, manufacturerLogoFront, manufacturerLogoBack, manufacturerLogoCenter, isEagleLogo);

				if (!isEagleLogo) {
					manufacturerLogoBack.material = manufacturerLogoFront.material;
					manufacturerLogoBack.visible = params.p_b_w == "Close" && manufacturerLogoFront.material.map != null && manufacturerLogoFront.material.map != undefined;
					manufacturerLogoBack.name = "manufacturerLogoBack";
					manufacturerLogoBack.renderOrder = new Date().getTime() + 3600 * 24 * 5000;
				} else {
					manufacturerLogoBack.visible = false;
				}

				manufacturerLogoCenter.material.map = texture;
				manufacturerLogoCenter.material.map.wrapS = THREE.RepeatWrapping;
				manufacturerLogoCenter.material.map.wrapT = THREE.RepeatWrapping;
				manufacturerLogoCenter.material.transparent = true;
				manufacturerLogoCenter.material.opacity = 1;
				manufacturerLogoCenter.material.needsUpdate = true;
				manufacturerLogoCenter.name = "manufacturerLogoCenter";
				manufacturerLogoCenter.visible = manufacturerLogoFront.material.map != null && manufacturerLogoFront.material.map != undefined;
				manufacturerLogoCenter.renderOrder = new Date().getTime() + 3600 * 24 * 5000;
			} catch (error) {
				if (manufacturerLogoFront != undefined) manufacturerLogoFront.visible = false;
				if (manufacturerLogoBack != undefined) manufacturerLogoBack.visible = false;
				if (manufacturerLogoCenter != undefined) manufacturerLogoCenter.visible = false;

				// console.log("Watermark not found")
			}
		} else {
			if (manufacturerLogoFront != undefined) manufacturerLogoFront.visible = false;
			if (manufacturerLogoBack != undefined) manufacturerLogoBack.visible = false;
			if (manufacturerLogoCenter != undefined) manufacturerLogoCenter.visible = false;
			if ("undefined" != typeof const_var.scene.getObjectByName("manufacturerLogoFront") && const_var.scene.getObjectByName("manufacturerLogoFront").visible == true)
				const_var.scene.getObjectByName("manufacturerLogoFront").visible = false;
			if ("undefined" != typeof const_var.scene.getObjectByName("manufacturerLogoBack") && const_var.scene.getObjectByName("manufacturerLogoBack").visible == true)
				const_var.scene.getObjectByName("manufacturerLogoBack").visible = false;
			if ("undefined" != typeof const_var.scene.getObjectByName("manufacturerLogoCenter") && const_var.scene.getObjectByName("manufacturerLogoCenter").visible == true)
				const_var.scene.getObjectByName("manufacturerLogoCenter").visible = false;
		}
	}
};

export const installationSurface = (installationSurfaceValue) => {
	// Center Building ground
	if (const_var.scene.getObjectByName("ground") != undefined) {
		try {
			const groundTextureUrl = require(`../../assets/images/installation-surface/${installationSurfaceValue}.jpg`).default;
			let leftLeanWidth = params.lean_p_w;
			let rightLeanWidth = params.leanR_p_w;
			let cover = 2;
			let borderWidth = 0.25;
			let repeatX = params.p_w;
			let repeatY = params.p_d;
			let borderWidthLeft = params.p_w / -2;
			let borderWidthRight = params.p_w / 2;
			let borderLengthFront = params.p_d / -2;
			let borderLengthBack = params.p_d / 2;

			if (params.leanStyle.left == "gable") {
				leftLeanWidth = params.lean_p_d;
			}
			if (params.leanStyle.right == "gable") {
				rightLeanWidth = params.leanR_p_d;
			}

			let ground = const_var.scene.getObjectByName("ground");
			ground.name = "ground";
			ground.scale.set(params.p_w + cover, params.p_d + cover, 1);
			ground.position.set(0, 0.05, 0);

			if (params.add_left_lean == true && params.add_right_lean == false) {
				ground.scale.x = params.p_w + leftLeanWidth + cover;
				ground.position.x = -leftLeanWidth / 2;
				repeatX = params.p_w + leftLeanWidth;
				borderWidthLeft = params.p_w / -2 - leftLeanWidth;
			} else if (params.add_left_lean == false && params.add_right_lean == true) {
				ground.scale.x = params.p_w + rightLeanWidth + cover;
				ground.position.x = rightLeanWidth / 2;
				repeatX = params.p_w + rightLeanWidth;
				borderWidthRight = params.p_w / 2 + rightLeanWidth;
			} else if (params.add_left_lean == true && params.add_right_lean == true) {
				ground.scale.x = params.p_w + rightLeanWidth + leftLeanWidth + cover;
				ground.position.x = -leftLeanWidth / 2 + rightLeanWidth / 2;
				repeatX = params.p_w + rightLeanWidth + leftLeanWidth;
				borderWidthLeft = params.p_w / -2 - leftLeanWidth;
				borderWidthRight = params.p_w / 2 + rightLeanWidth;
			} else {
				ground.scale.x = params.p_w + cover;
				ground.position.x = 0;
			}

			if (params.add_front_lean == true && params.add_back_lean == false) {
				ground.scale.y = params.p_d + params.leanF_p_w + cover;
				ground.position.z = params.leanF_p_w / 2;
				repeatY = params.p_d + params.leanF_p_w;
				borderLengthFront = params.p_d / -2 - params.leanF_p_w;
			} else if (params.add_front_lean == false && params.add_back_lean == true) {
				ground.scale.y = params.p_d + params.leanB_p_w + cover;
				ground.position.z = -params.leanB_p_w / 2;
				repeatY = params.p_d + params.leanB_p_w;
				borderLengthBack = params.p_d / 2 + params.leanB_p_w;
			} else if (params.add_front_lean == true && params.add_back_lean == true) {
				ground.scale.y = params.p_d + params.leanB_p_w + params.leanF_p_w + cover;
				ground.position.z = -params.leanB_p_w / 2 + params.leanF_p_w / 2;
				repeatY = params.p_d + params.leanB_p_w + params.leanF_p_w;
				borderLengthFront = params.p_d / -2 - params.leanF_p_w;
				borderLengthBack = params.p_d / 2 + params.leanB_p_w;
			} else {
				ground.scale.y = params.p_d + cover;
				ground.position.z = 0;
			}

			if (params.isShowCenter) {
				ground.scale.set(params.p_w + cover, params.p_d + cover, 1);
				ground.position.set(0, 0.05, 0);
				borderWidthLeft = params.p_w / -2;
				borderWidthRight = params.p_w / 2;
				borderLengthFront = params.p_d / -2;
				borderLengthBack = params.p_d / 2;
			}

			ground.rotation.x = Math.PI / -2;
			ground.visible = true;
			let loader = new THREE.TextureLoader();
			let groundTexture = loader.load(`${process.env.REACT_APP_BASE_URL}${groundTextureUrl}`, function (textureImg) {
				groundTexture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
				ground.material.map = textureImg;
				ground.material.bumpMap = textureImg;
				ground.material.bumpScale = 1;
				ground.material.map.wrapS = THREE.RepeatWrapping;
				ground.material.map.wrapT = THREE.RepeatWrapping;
				ground.material.map.repeat.set(repeatX / 10, repeatY / 10);
				ground.material.needsUpdate = true;
			});
		} catch (error) {
			console.log("Error loading file:", error);
		}
	}
};

export function findNearestMultipleOfFour(number) {
	let remainder = number % 4;
	let nearestMultiple = number - remainder;

	if (remainder > 2) {
		nearestMultiple += 4;
	}

	return nearestMultiple;
}

export function findNearestMultipleOfFive(number) {
	const remainder = number % 5;

	if (remainder <= 2) {
		return number - remainder;
	}

	return number + (5 - remainder);
}
export const updateCenterBuildingPricesOnLeanAPICalls = (state, leanType, mainType) => {
	if ((leanType == "leanGetDataLeft" || leanType == "leanGetDataRight") && const_var[leanType] != undefined && const_var[leanType].central_panel != undefined && const_var[leanType].central_panel.length > 0) {
		const_var.a_p_d_a.panel = const_var[leanType].central_panel;
		if (const_var.checkPanelForLean.left && leanType == "leanGetDataLeft") const_var.UpdatedPriceData.left_wall_price_changed = true;
		if (const_var.checkPanelForLean.right && leanType == "leanGetDataRight") const_var.UpdatedPriceData.right_wall_price_changed = true;
	}
	if (const_var[leanType] != undefined && const_var[leanType].central_building_structure != undefined && const_var[leanType].central_building_structure.length > 0) {
		const_var.a_p_d_a.building_structure = const_var[leanType].central_building_structure;
		if (const_var.a_p_d_a?.building_structure[0]?.conditions != undefined && const_var.a_p_d_a.building_structure[0]?.conditions["Leg_Height_condition"] != undefined) {
			let checkCenterLeg = const_var.a_p_d_a.building_structure[0].conditions["Leg_Height_condition"].find((s) => s.legs_type == const_var.legstype);
			if (checkCenterLeg == undefined) {
				let reinforeced = const_var.a_p_d_a.building_structure[0].conditions["Leg_Height_condition"].find((data) => data.legs_type == "Single" || data.legs_type == "single");
				if (reinforeced != undefined) {
					reinforeced.legs_type = "reinforced";
				}
				checkLegsDataAccordingtoResponse(const_var.ConditionArr[params.p_b_t][params.p_r_s]);
			}
			checkleanLegsDataAccordingtoResponse(const_var.ConditionArr[params.p_b_t][params.p_r_s]);
			cuBuilding.CheckLegsByResponse(state);
		}
	}
};

export const convertToTwoDecimalNumber = (price) => {
	price = parseFloat(price);
	let convertToTwoDecimal = Number.isInteger(price) ? price : price.toFixed(2);
	let convertToNumber = parseFloat(convertToTwoDecimal);

	return convertToNumber;
};
export function sortArrayStrings(array, property) {
	if (array.length === 0) return array; // Return empty array as is

	if (typeof array[0] === "string") {
		return array.sort((a, b) => a.localeCompare(b));
	} else if (typeof array[0] === "object" && property) {
		return array.sort((a, b) => {
			const valA = a[property] ? a[property].toLowerCase() : "";
			const valB = b[property] ? b[property].toLowerCase() : "";

			if (valA < valB) return -1;
			if (valA > valB) return 1;
			return 0;
		});
	} else {
		throw new Error("Unsupported array type or missing property for object sorting.");
	}
}

export const isJsonString = (str) => {
	try {
		return JSON.parse(str);
	} catch (e) {
		return str;
	}
};

export const copyToClickboard = (from) => {
	var copyText = document.getElementById("my-text-area");
	let copyTextValue = "";
	if (from == "innerHTML") {
		copyTextValue = copyText.innerText;
	} else {
		copyText.select();
		copyText.setSelectionRange(0, 99999);
		copyTextValue = copyText.value;
	}
	navigator.clipboard.writeText(copyTextValue);
};

export const textureRepeat = (name, gl) => {
	const baseUrl = process.env.REACT_APP_BASE_URL;
	try {
		const img = require(`../../assets/images/texture/building/${name}.webp`);
		const texture = new THREE.TextureLoader().load(`${baseUrl}${img}`);
		let repeatX = 1.3;
		let repeatY = 1.3;
		switch (name) {
			case "wood_siding":
				repeatX = 0.15;
				repeatY = 0.15;
				break;
			case "lap_siding":
				repeatY = 0.3;
				break;
			case "board_and_batten_siding":
			case "board_and_batten_metal_siding":
				repeatX = 0.75;
				break;
			case "stackstone_ash_siding":
			case "stackstone_shadow_siding":
			case "stackstone_smoke_siding":
				repeatX = 0.2;
				repeatY = 0.2;
				break;
			case "real_tree_siding":
			case "brick_siding":
			case "stone_siding":
				repeatX = 0.22;
				repeatY = 0.27;
				break;
			case "camo_siding":
				repeatX = 0.22;
				repeatY = 0.1;
				break;
			default:
				repeatX = 1.3;
				repeatY = 1.3;
				break;
		}
		textureAnisotropy(undefined, texture, repeatX, repeatY, Math.PI / -2, gl);
		const_var.wallTextureObj[name] = texture;
	} catch (error) {
		console.error("Texture image not found : ", error);
	}
};

export const editCaseHeritage = () => {
	let heritageEditCase =
		const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined;

	return heritageEditCase;
};

export const setDefaultValuesOnSalesLoginBtnClick = () => {
	const_var.tempZCode = "";
	const_var.ziperrormsg = "";
	const_var.displayerrorMessage = {};
	const_var.checkValidatePattern = false;
	const_var.state_mfg_zipcode = "";
	const_var.state_mfg_zipcode_old = "";
	const_var.resetVal = true;
	const_var.hideZipCodeField = false;
	const_var.zipManufErrMsg = "";
	setTimeout(() => {
		window.document.getElementById("username").focus();
	}, 10);
};

export const isColorLight = (hex) => {
	hex = hex.replace("#", "");

	if (hex.length === 3) {
		hex = hex
			.split("")
			.map((char) => char + char)
			.join("");
	}

	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);

	const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

	return luminance > 0.6;
};

export const checkName = (building_names) => {
	let arr = [];
	let tempName = "";
	if (building_names?.includes("Carport")) {
		arr.push("Carports");
	}
	if (building_names?.includes("Garage")) {
		tempName = arr.length > 0 ? ", Garages" : "Garages";
		arr.push(tempName);
	}
	if (building_names?.includes("Commercial")) {
		tempName = arr.length > 0 ? ", Commercials" : "Commercials";
		arr.push(tempName);
	}
	if (building_names?.includes("Barn")) {
		tempName = arr.length > 0 ? ", Barns" : "Barns";
		arr.push(tempName);
	}
	if (building_names?.includes("RV")) {
		tempName = arr.length > 0 ? ", RV Covers" : "RV Covers";
		arr.push(tempName);
	}
	if (building_names?.includes("Standing")) {
		tempName = arr.length > 0 ? ", Free Standings" : "Free Standings";
		arr.push(tempName);
	}
	if (building_names == "All Buildings") {
		return building_names;
	} else {
		return arr;
	}
};

export const convertToAdjustedFeetInches = (value, minLimit, maxLimit) => {
	let sign = Math.sign(value);
	let feet = Math.floor(Math.abs(value));
	let inch = Math.floor((Math.abs(value) - feet) * 12);
	let finalInch = inch * 0.08333333333333333;
	let inch1 = finalInch.toFixed(3).split(".")[1];
	let finalValue = Number(`${feet}.${inch1}`) * sign;

	if (finalValue < minLimit) {
		finalValue = Math.ceil(minLimit * 100) / 100;
	}
	if (finalValue > maxLimit) {
		finalValue = Math.ceil(maxLimit * 100) / 100;
	}

	return finalValue;
};

async function hashSHA256(apiToken, domain) {
	const encoder = new TextEncoder();
	const data = encoder.encode(apiToken + domain); // Concatenate the apiToken and domain
	const hashBuffer = await window.crypto.subtle?.digest("SHA-256", data); // Hash the data using SHA-256
	const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert the ArrayBuffer to an array of bytes
	const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join(""); // Convert bytes to hex string
	return hashHex;
}

export const decodeKey = async (checkoutKey, const_var) => {
	const apiToken = const_var.crmSetting.api_token;
	const domain = const_var.crmSetting.main_domain_url;
	const haskKey = await hashSHA256(apiToken, domain);

	const decryptedText = await decryptString(checkoutKey, haskKey);

	return decryptedText;
};

async function encryptString(string, keyString) {
	const encoder = new TextEncoder();
	const data = encoder.encode(string);

	const key = await crypto.subtle.digest("SHA-256", encoder.encode(keyString)); // Pass keyString here

	const iv = crypto.getRandomValues(new Uint8Array(16));

	const cryptoKey = await crypto.subtle.importKey("raw", key, { name: "AES-CBC" }, false, ["encrypt"]);

	const encryptedData = await crypto.subtle.encrypt({ name: "AES-CBC", iv: iv }, cryptoKey, data);

	const combined = new Uint8Array(iv.byteLength + encryptedData.byteLength);
	combined.set(iv, 0); // Add the IV to the beginning
	combined.set(new Uint8Array(encryptedData), iv.byteLength); // Add the encrypted data

	return base64Encode(combined);
}

// Helper to convert to base64
function base64Encode(buffer) {
	return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
}

// Decryption Function
async function decryptString(encryptedString, keyString) {
	const decoder = new TextDecoder();
	const data = base64Decode(encryptedString);
	const iv = data.slice(0, 16); // The first 16 bytes are the IV
	const encryptedData = data.slice(16); // The remaining part is the encrypted data
	const encoder = new TextEncoder();
	const key = await crypto.subtle?.digest("SHA-256", encoder.encode(keyString)); // Hash the key string to 256-bit
	const cryptoKey = await crypto.subtle?.importKey("raw", key, { name: "AES-CBC" }, false, ["decrypt"]);
	const decryptedData = await crypto.subtle?.decrypt({ name: "AES-CBC", iv: iv }, cryptoKey, encryptedData);
	return decoder.decode(decryptedData);
}

// Helper to decode base64
function base64Decode(base64) {
	const binaryString = atob(base64); // Decode base64 string to binary string
	const byteArray = new Uint8Array(binaryString.length); // Create a byte array

	for (let i = 0; i < binaryString.length; i++) {
		byteArray[i] = binaryString.charCodeAt(i);
	}
	return byteArray;
}
export const loadStripe = (dynamicKey) => {
	if (!window.document.getElementById("stripe-script")) {
		var s = window.document.createElement("script");
		s.id = "stripe-script";
		s.type = "text/javascript";
		s.src = "https://js.stripe.com/v2/";
		s.onload = () => {
			window["Stripe"].setPublishableKey(dynamicKey);
		};
		window.document.body.appendChild(s);
	}
};

export const checkAdditionalChargesData = () => {
	const_var.additionalChargeArr.forEach((data) => {
		if (data.name == "" && data.price != 0) {
			data.name = "Additional Component";
		}
	});
	let additionalChargeArr = const_var.additionalChargeArr.filter((data, ind) => data.name != "");
	return additionalChargeArr;
};

export const checkColoredScrewsForLeanto = (leanType, a_p_d_a) => {
	let showoptionSelected =
		params.m_s_n != 184 || (params.m_s_n == 184 && (const_var.crmSetting.is_Edit != true || (const_var.crmSetting.is_Edit == true && (const_var.isFromCompare == true || const_var.isFromPickThis == true))))
			? true
			: false;
	let check = const_var.crmSetting.form_action == "create" || const_var.isCheckColoredScrews;
};

export const isNumberInRange = (rangeStr, num, applyOn) => {
	if (applyOn == "width") {
		const [min, max] = rangeStr.split("-").map(Number); // Extract min and max as numbers
		return num >= min && num <= max;
	} else {
		for (const range in rangeStr) {
			const [min, max] = range.split("-").map(Number); // Extract min and max values
			if (num >= min && num <= max) {
				return rangeStr[range]; // Return the corresponding value
			}
		}
		return null; // Return null if no match is found
	}
};
export const isCheckCustomSizeInRange = (parentkey, rangeStr, width, height, fromComponent) => {
	let finalData = "";
	if (fromComponent == undefined) {
		rangeStr.map((data) => {
			const [min, max] = parentkey == "Garage_Frameout" ? data.frame_out_length.split("-").map(Number) : data.width_range.split("-").map(Number);
			const [minHeight, maxHeight] = parentkey == "Garage_Frameout" ? data.frame_out_height.split("-").map(Number) : data.height_range.split("-").map(Number);
			if (Number(width) >= min && Number(width) <= max && Number(height) >= minHeight && Number(height) <= maxHeight) {
				finalData = data;
			}
		});
		return finalData;
	} else {
		let min = 0;
		let max = 0;
		if (fromComponent == "width") {
			min = Number(Math.min(...rangeStr.map((item) => Number(parentkey == "Garage_Frameout" ? item.frame_out_length.split("-")[0] : item.width_range.split("-")[0]))));
			max = Number(Math.max(...rangeStr.map((item) => Number(parentkey == "Garage_Frameout" ? item.frame_out_length.split("-")[1] : item.width_range.split("-")[1]))));
		} else {
			min = Number(Math.min(...rangeStr.map((item) => Number(parentkey == "Garage_Frameout" ? item.frame_out_height.split("-")[0] : item.height_range.split("-")[0]))));
			max = Number(Math.max(...rangeStr.map((item) => Number(parentkey == "Garage_Frameout" ? item.frame_out_height.split("-")[1] : item.height_range.split("-")[1]))));
		}
		finalData = min + "-" + max;
		return finalData;
	}
};

export const surfaceCertificateApplied = (state, compare, compareData) => {
	if (compare == true) {
		if (compareData?.paramsData?.p_i_s != undefined && compareData?.paramsData.p_i_s != "1") {
		}
	} else {
		if (params.p_i_s != undefined && params.p_i_s != "1") {
		} else if (params.p_i_s != undefined && params.p_i_s == "1") {
		}
	}
};
export const setZeroPriceOverhang = (response) => {
	if (response.overhang) {
		if (response.overhang.end?.length > 0) {
			response.overhang.end.forEach((item) => {
				if (item.is_included != undefined && item.is_included == 1) {
					// item.cost = 0
					// item.side_cost = 0
					// item.end_cost = 0
				}
			});
		}
		if (response.overhang.side?.length > 0) {
			response.overhang.side.forEach((item) => {
				if (item.is_included != undefined && item.is_included == 1) {
					// item.cost = 0
					// item.side_cost = 0
					// item.end_cost = 0
				}
			});
		}
		if (response.overhang?.both != undefined && response.overhang?.both != "") {
			if (response.overhang?.both.is_included != undefined && response.overhang?.both.is_included == 1) {
				// response.overhang.both.cost = 0
				// response.overhang.both.side_cost = 0
				// response.overhang.both.end_cost = 0
			}
		}
	}
};

export const sidingNameUpdateForWallTexture = (sidingName) => {
	let updatedWallTexture = "";
	if (sidingName?.includes("horizontal")) {
		updatedWallTexture = sidingName.split("_horizontal")[0];
	} else if (sidingName?.includes("vertical")) {
		updatedWallTexture = sidingName.split("_vertical")[0];
	} else {
		updatedWallTexture = sidingName;
	}
	return updatedWallTexture;
};

export const findWainscotTexture = (data) => {
	let sidingName = data.image_name?.split(".")[0];
	let wainscotTexture = "none";
	if (sidingName != undefined) {
		wainscotTexture = sidingNameUpdateForWallTexture(sidingName);
	} else if (data.sheet_name == "metal") {
		if (params.wallOrientation != undefined && params.wallOrientation != "") {
			wainscotTexture = params.wallOrientation == "vertical" ? "vertical" : "none";
		} else {
			if (params.p_v_w == true) {
				wainscotTexture = "vertical";
			} else {
				wainscotTexture = "none";
			}
		}
	} else if (data.sheet_name == undefined) {
		if (params.p_v_w == true) {
			wainscotTexture = "vertical";
		} else {
			wainscotTexture = "none";
		}
	} else {
		wainscotTexture = sidingNameUpdateForWallTexture(data.sheet_name);
	}

	return wainscotTexture;
};

export const sleep = (milliseconds) => {
	return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export const getLeantoMapId = () => {
	let mapId = const_var.Map_Id[params.p_b_t];
	if (const_var.SendAPIBuildingData !== undefined && const_var.SendAPIBuildingData.building !== undefined && const_var.SendAPIBuildingData.building.length > 0) {
		const_var.SendAPIBuildingData.building.map((item) => {
			if (item.building_type.heavy_snow == 1 && const_var.CheckSnowLoadValue == 65) {
				if (item.building_type.building_id == const_var.c_m_a[params.p_b_t].default_lean_id) {
					mapId = item.building_type.map_id;
				}
			}
			if (item.building_type.heavy_snow == 0 && const_var.CheckSnowLoadValue != 65) {
				if (item.building_type.building_id == const_var.c_m_a[params.p_b_t].default_lean_id) {
					mapId = item.building_type.map_id;
				}
			}
		});
	} else {
		if (const_var.c_m_a[params.p_b_t].defaultBuldingcheck == 1) {
			mapId = const_var.Map_Id[params.p_b_t];
		} else {
			mapId = const_var.mapIdforLean;
		}
	}
	return mapId;
};

export const checkBuildingTypeCategory = (img_name) => {
	let tempBuild = {};
	if (img_name.includes("Carport") || img_name.includes("Utility_Buildings")) {
		tempBuild.type = "caport";
	} else if (img_name.includes("Garage")) {
		tempBuild.type = "garage";
	} else if (img_name.includes("Commercial")) {
		tempBuild.type = "commercial";
	} else if (img_name.includes("Barn")) {
		tempBuild.type = "barn";
	} else if (img_name.includes("RV")) {
		tempBuild.type = "rvcover";
	} else if (img_name.includes("Standing")) {
		tempBuild.type = "freestanding";
	} else if (img_name.includes("Custom")) {
		tempBuild.type = "custom";
	} else if (img_name.includes("shape")) {
		tempBuild.type = "landt";
	}
	tempBuild.name = const_var.post_data.building.display_building_type_name.replace(/ /g, "").toLocaleLowerCase();

	return tempBuild;
};

export const setLNTBuildingData = (key, index, obj, leanType) => {
	let sanitizedObj = obj != undefined ? JSON.parse(JSON.stringify(obj)) : obj;
	const lean_Type = const_var.selectedLeanType || "centerBuilding";
	let targetArray = const_var.lNTBuildingData?.[key]?.[lean_Type];

	if (key == "certificate") {
		targetArray[0] = index;
	} else {
		if (sanitizedObj?.is_checked) {
			if (key === "ExtraItemsFeaturesArrayForOverhangComputation") {
				const_var.lNTBuildingData["ExtraItemsFeaturesArrayForOverhangComputation"][leanType][index] = { ...sanitizedObj };
			} else if (key === "extraAddOnItemsArray") {
				if (const_var.lNTBuildingData?.["extraAddOnItemsArray"]?.[lean_Type]?.[index] == undefined) {
					const_var.lNTBuildingData["extraAddOnItemsArray"][lean_Type][index] = {};
				}
				const_var.lNTBuildingData["extraAddOnItemsArray"][lean_Type][index] = { ...sanitizedObj };
			} else if (key == "ExtraItemsFeaturesArray" && (sanitizedObj.name === "fourth_center_cost" || sanitizedObj?.sheet_name?.toLocaleLowerCase().includes("overhang"))) {
				const_var.lNTBuildingData[key]["centerBuilding"][index] = { ...sanitizedObj };
			} else {
				targetArray[index] = { ...sanitizedObj };
			}
		} else {
			if (key === "ExtraItemsFeaturesArrayForOverhangComputation") {
				const_var.lNTBuildingData[key][leanType][index] = undefined;
			} else if (key === "extraAddOnItemsArray") {
				const_var.lNTBuildingData["extraAddOnItemsArray"][lean_Type][index] = undefined;
			} else if (
				(key == "ExtraItemsFeaturesArray" || key == "ExtraItemsFeaturesArrayForOverhangComputation") &&
				(sanitizedObj.name === "fourth_center_cost" || sanitizedObj?.sheet_name?.toLocaleLowerCase().includes("overhang"))
			) {
				const_var.lNTBuildingData[key]["centerBuilding"][index] = undefined;
			}
			targetArray[index] = undefined;
		}
	}
};

export const updateCPAccordingToLNTBuilding = () => {
	const selectedLeanType = const_var.selectedLeanType === "" ? "centerBuilding" : const_var.selectedLeanType;

	if (const_var.lNTBuildingData["ExtraItemsFeaturesArray"][selectedLeanType]) {
		const_var.ExtraItemsFeaturesArray = structuredClone(const_var.lNTBuildingData["ExtraItemsFeaturesArray"][selectedLeanType]);
	}

	if (const_var.lNTBuildingData["ExtraItemsFeaturesQuantityArray"][selectedLeanType]) {
		const_var.ExtraItemsFeaturesQuantityArray = structuredClone(const_var.lNTBuildingData["ExtraItemsFeaturesQuantityArray"][selectedLeanType]);
	}
	if (const_var.lNTBuildingData["additionalFeaturesArray"][selectedLeanType]) {
		const_var.additionalFeaturesArray = structuredClone(const_var.lNTBuildingData["additionalFeaturesArray"][selectedLeanType]);
	}
	if (const_var.lNTBuildingData?.["extraAddOnItemsArray"]?.[selectedLeanType]) {
		const_var.extraAddOnItemsArray = structuredClone(const_var.lNTBuildingData["extraAddOnItemsArray"][selectedLeanType]);
	}
};

export const backupUpdatedPriceDataElements = (const_var, allUpdatedPriceElements) => {
	const_var.lNTBuildingData.updatePriceDataElements = JSON.parse(JSON.stringify(allUpdatedPriceElements));
};

export const restoreUpdatedPriceDataElements = () => {
	const lean_Type = const_var.selectedLeanType || "centerBuilding";
	const object = const_var.lNTBuildingData["updatePriceDataElements"][lean_Type];
	const array = [];
	Object.entries(object).forEach(([key, value]) => {
		array[key.toString()] = value;
	});
	const_var.UpdatedPriceData.elements = array;
};

export const hasGableLeanto = (leanType) => {
	return const_var.post_data?.building?.leanto?.find((l) => {
		return LEAN_TYPE_NUM_TO_STR[l.leanto_type] === leanType && l.leanto_style == "gable";
	});
};

export const getMeLeanToPrices = (post_data) => {
	let leantoPriceCalculation = {
		totalLeanPrice: 0,
		totalBasePrice: 0,
		totalWallPrice: 0,
		totalHeightPrice: 0,
		totalDimension: 0,
		totalEndWallPrice: 0,
		totalSideWallPrice: 0
	};

	post_data?.building?.leanto?.forEach((lean) => {
		if (lean.leanto_style === "standard") {
			leantoPriceCalculation.totalLeanPrice += parseFloat(lean.t_c_b);
			leantoPriceCalculation.totalSideWallPrice += parseFloat(lean.side_wall_price);
			leantoPriceCalculation.totalEndWallPrice += parseFloat(lean.front_wall_price) + parseFloat(lean.back_wall_price);
			leantoPriceCalculation.totalHeightPrice += parseFloat(lean.height_price);
			leantoPriceCalculation.totalDimension += parseFloat(leantoPriceCalculation.totalDimension);

			leantoPriceCalculation.totalWallPrice += parseFloat(lean.front_wall_price) + parseFloat(lean.back_wall_price) + parseFloat(lean.side_wall_price);
			if (lean.utility_price != undefined && lean.utility_price != 0) {
				leantoPriceCalculation.totalWallPrice += parseFloat(lean.utility_price);
			}

			leantoPriceCalculation.totalBasePrice += parseFloat(lean.basic_price);
			if (isNaN(parseFloat(leantoPriceCalculation.totalBasePrice)) == true) {
				leantoPriceCalculation.totalBasePrice = 0;
			}
		}
	});

	return leantoPriceCalculation;
};

export const capitalize = (word) => {
	if (!word) return "";
	return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const textureAppliedFor = (textureObj, isFor) => {
	let texture = params.wallOrientation != "" && const_var.selSidingOption != "metal" ? textureObj : null;
	if (isFor == "wainscot")
		texture =
			params.wallOrientation != "" &&
			params.wainscotTexture != "none" &&
			params.wainscotTexture != "vertical" &&
			params.wainscotTexture != "lap_siding" &&
			params.wainscotTexture != "board_and_batten_siding" &&
			params.wainscotTexture != "board_and_batten_metal_siding"
				? textureObj
				: null;
	return texture;
};

export const getImage = (texture) => {
	if (texture?.includes("stone")) {
		try {
			return require(`../../assets/images/color-image/${texture}.svg`);
		} catch (err) {
			console.log(`${texture} image not found`);
		}
	}
	return "";
};

export const manufacturerLogo = () => {
	return new Promise((resolve) => {
		const token = const_var?.crmSetting?.parent_api_token;
		if (!token) return resolve(null);

		const url = `https://cdn.sensei3d.com/manufacturer_logo/${token}.svg`;
		const img = new Image();

		img.onload = () => resolve(url); // If image loads successfully
		img.onerror = () => resolve(null); // If image fails to load (404, etc.)

		img.src = url;
	});
};

export const onWidthHeightChange = (width, height) => {
	if (const_var.hide_price_calculation == 0) {
		const currentWidth = parseFloat(width);
		const currentHeight = parseFloat(height);
		if (const_var.loginSession == false && const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && (currentHeight > 12 || currentWidth > 30)) {
			const_var.hide_price_calculation = 1;
			document.querySelector("body").classList.add("active-hidden-price");

			const_var.crmSetting.order_now = false;
		} else {
			const_var.hide_price_calculation = 0;
			document.querySelector("body").classList.remove("active-hidden-price");

			const_var.crmSetting.order_now = const_var.stateData.is_online_checkout == 1 ? true : false;
		}
	}
};

let sidingTextureNames = [
	"vertical",
	"none",
	"lap_siding",
	"board_and_batten_siding",
	"board_and_batten_metal_siding",
	"wood_siding",
	"stackstone_ash_siding",
	"stackstone_shadow_siding",
	"stackstone_smoke_siding",
	"stone_siding",
	"brick_siding",
	"real_tree_siding",
	"camo_siding"
];

export const getSimilarTexture = (texture) => {
	const matched = sidingTextureNames.find((name) => texture?.includes(name));
	return matched || texture;
};

export const createSidingTextureObject = () => {
	let similarSidingTextures = getSimilarTexture(params.wallTexture);
	let similarWainscotTextures = getSimilarTexture(params.wainscotTexture);

	const texture = const_var.wallTextureObj?.[similarSidingTextures]?.clone();
	const wainscotTexture = const_var.wallTextureObj?.[similarWainscotTextures]?.clone();
	const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
	const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();

	if (metalTexture) {
		if (params.wallOrientation == "vertical") metalTexture.rotation = 0;
		else metalTexture.rotation = Math.PI / -2;
	}
	if (lightTexture) lightTexture.rotation = metalTexture.rotation;
	if (texture && const_var.selSidingOption == "metal") texture.rotation = metalTexture.rotation;
	if (wainscotTexture && (params.wainscotTexture == "none" || params.wainscotTexture == "vertical")) wainscotTexture.rotation = metalTexture.rotation;

	return { texture: texture, wainscotTexture: wainscotTexture, metalTexture: metalTexture, lightTexture: lightTexture };
};

export const createSidingInnerTexture = (gl) => {
	if (const_var.metalTexture) {
		let similarSidingTextures = getSimilarTexture(params.wallTexture);
		let texture =
			const_var.wallTextureObj[similarSidingTextures] != undefined && (similarSidingTextures == "lap_siding" || similarSidingTextures.includes("board_and_batten"))
				? const_var.wallTextureObj[similarSidingTextures].clone()
				: const_var.metalTexture.clone();
		let rotation =
			params.wallOrientation == "vertical"
				? true
				: params.wallOrientation == "horizontal"
					? false
					: similarSidingTextures == "lap_siding" || similarSidingTextures.includes("board_and_batten")
						? false
						: params.p_v_w;
		let repeatX = 1.3;
		let repeatY = 1.3;
		if (similarSidingTextures == "lap_siding") repeatY = 0.3;
		else if (similarSidingTextures.includes("board_and_batten")) repeatX = 0.75;
		textureAnisotropy(gl, texture, repeatX, repeatY, rotation ? Math.PI / -2 : 0);
		return texture;
	} else {
		return null;
	}
};

export const extractDataFromInner = (data) => {
	const componentMap = new Map();
	for (const categoryKey in data) {
		const category = data[categoryKey];
		if (typeof category !== "object" || Array.isArray(category)) continue;
		for (const componentName in category) {
			const componentObj = category[componentName];
			if (!componentMap.has(componentName)) {
				componentMap.set(componentName, componentObj);
			}
		}
	}
	const uniqueComponentObjects = Array.from(componentMap.values());
	return uniqueComponentObjects;
};

export const wallSelectionChangesForLNTBuilding = (state, calFor, callCP) => {
	if ((calFor == "all" || calFor == "left") && state.params.leanStyle.left === "gable" && state.params.p_l_w == "Close" && state.params.p_b_c_b_l_b == "Close") {
		state.params.p_b_c_b_l_b = "Open";
		cuBuilding.UpdateLeftLean("walls");
		if (callCP === true) {
			cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
		}
	}
	if ((calFor == "all" || calFor == "right") && state.params.leanStyle.right === "gable" && state.params.p_r_w == "Close" && state.params.p_b_c_b_r_b == "Close") {
		state.params.p_b_c_b_r_b = "Open";
		cuBuilding.UpdateRightLean("walls");
		if (callCP === true) {
			cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
		}
	}
	if ((calFor == "all" || calFor == "front") && state.params.leanStyle.front === "gable" && state.params.p_f_w == "Close" && state.params.p_b_c_b_f_b == "Close") {
		state.params.p_b_c_b_f_b = "Open";
		cuBuilding.UpdateFrontLean("walls");
		if (callCP === true) {
			cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
		}
	}
	if ((calFor == "all" || calFor == "back") && state.params.leanStyle.back === "gable" && state.params.p_b_w == "Close" && state.params.p_b_c_b_b_b == "Close") {
		state.params.p_b_c_b_b_b = "Open";
		cuBuilding.UpdateBackLean("walls");
		if (callCP === true) {
			cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
		}
	}
};

export const detectDeviceInfo = () => {
	const ua = navigator.userAgent || navigator.vendor || window.opera;
	let os = "Unknown OS";
	let deviceType = "Unknown Device";

	if (navigator.userAgentData) {
		const platform = navigator.userAgentData.platform || "unknown";
		if (/Windows/i.test(platform)) os = "Windows";
		else if (/macOS/i.test(platform)) os = "macOS";
		else if (/Android/i.test(platform)) os = "Android";
		else if (/iOS/i.test(platform)) os = "iOS";
		else if (/Linux/i.test(platform)) os = "Linux";
		else os = platform;
	} else {
		if (/Windows NT/i.test(ua)) os = "Windows";
		else if (/Macintosh/i.test(ua)) os = "macOS";
		else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
		else if (/Android/i.test(ua)) os = "Android";
		else if (/Linux/i.test(ua)) os = "Linux";
	}

	const isIpad = (() => {
		return (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) || /iPad/.test(ua);
	})();

	if (isIpad) {
		deviceType = "Tablet";
		os = "iOS";
	} else if (/Mobi|Android|iPhone|iPod|BlackBerry|Phone/i.test(ua)) {
		deviceType = "Mobile";
	} else if (/Tablet|PlayBook|Silk|Kindle/i.test(ua)) {
		deviceType = "Tablet";
	} else {
		deviceType = "Desktop";
	}

	return {
		dimension: window.innerWidth + " X " + window.innerHeight,
		operating_system: os,
		device: deviceType
	};
};

export const shortenUrl = async (longUrl) => {
	try {
		const response = await axios.post(
			"https://api-ssl.bitly.com/v4/shorten",
			{
				long_url: longUrl,
				domain: "bit.ly"
			},
			{
				headers: {
					Authorization: `Bearer bd25b55ae07c7978b806e350971dbfa278aaf023`,
					"Content-Type": "application/json"
				}
			}
		);
		return response.data.link;
	} catch (error) {
		console.error("Error shortening URL:", error);
	}
};
export const initiallyLoadTextures = async () => {
	const gltfLoader = new GLTFLoader();
	const baseUrl = window.location.hostname === "localhost" ? "" : process.env.REACT_APP_BASE_URL;

	try {
		const metalTexture = new THREE.TextureLoader().load(`${baseUrl}${MetalStripeImg}`);
		const Trim_Texture = new THREE.TextureLoader().load(`${baseUrl}${TrimTexture}`);
		const textureGrass = new THREE.TextureLoader().load(`${baseUrl}${GrassBackground}`);
		const textureGray = new THREE.TextureLoader().load(`${baseUrl}${GrayBackground}`);
		const skyIMG = new THREE.TextureLoader().load(`${baseUrl}${SKY_IMG}`);
		const groundIMG = new THREE.TextureLoader().load(`${baseUrl}${GROUND_IMG}`);

		function getMaxAnisotropyManual() {
			const canvas = document.createElement("canvas");
			const gl = canvas?.getContext("webgl");
			const ext = gl?.getExtension("EXT_texture_filter_anisotropic");
			return ext ? gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 1;
		}

		let gl = const_var.renderer ? const_var.renderer.capabilities.getMaxAnisotropy() : getMaxAnisotropyManual();

		let textureNames = [
			"vertical",
			"vertical_light",
			"none",
			"lap_siding",
			"board_and_batten_siding",
			"board_and_batten_metal_siding",
			"wood_siding",
			"stackstone_ash_siding",
			"stackstone_shadow_siding",
			"stackstone_smoke_siding",
			"stone_siding",
			"brick_siding",
			"real_tree_siding",
			"camo_siding"
		];
		textureNames.forEach((name) => textureRepeat(name, gl));

		const envTexture = new THREE.CubeTextureLoader().load([
			`${baseUrl}${ReflectLegTexturePX}`,
			`${baseUrl}${ReflectLegTextureNX}`,
			`${baseUrl}${ReflectLegTexturePY}`,
			`${baseUrl}${ReflectLegTextureNY}`,
			`${baseUrl}${ReflectLegTexturePZ}`,
			`${baseUrl}${ReflectLegTextureNZ}`
		]);

		const_var.metalTexture = metalTexture;
		const_var.TrimTexture = Trim_Texture;
		const_var.textureGrass = textureGrass;
		const_var.textureGray = textureGray;
		const_var.skyIMG = skyIMG;
		const_var.groundIMG = groundIMG;
		const_var.envIMG = envTexture;
	} catch (error) {
		console.error("Error loading textures:", error);
	}
	try {
		const [gltf, gltf1] = await Promise.all([gltfLoader.loadAsync(`${baseUrl}/assets/glbModels/handle_sphere.glb`), gltfLoader.loadAsync(`${baseUrl}/assets/glbModels/handle_rect_group.glb`)]);
		const_var.loadGltObj = gltf.scene?.children[0]?.children[0];
		if (gltf1.scene) {
			const_var.loadGltObj1 = {
				white_section: gltf1.scene.getObjectByName("white_section"),
				handle: gltf1.scene.getObjectByName("handle"),
				black_section: gltf1.scene.getObjectByName("black_section")
			};
		}
	} catch (error) {
		console.error("Error loading GLTF model:", error);
	}
};
export const straightRoofDistance = (p_r_s, centerRoofPitch, leanRoofPitch, roofRegularDst, iiD) => {
	let olderThen31Oct =
		const_var.crmSetting.is_Edit == true &&
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data != undefined &&
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data.main_created_at != undefined &&
		const_var.editAPIDataByResponse.data.main_created_at <= "2025-11-05" &&
		const_var.isFromPickThis != true
			? true
			: false;
	let distanceValue = 1;
	let isdistanceAvailable = false;
	let msn = iiD ? Number(iiD) : Number(params.m_s_n);
	switch (msn) {
		case 3:
			distanceValue = 1;
			isdistanceAvailable = true;
			break;
		case 153:
			distanceValue = 1;
			isdistanceAvailable = true;
			break;
		default:
			distanceValue = 1;
			isdistanceAvailable = false;
			break;
	}

	let distance = centerRoofPitch == leanRoofPitch || olderThen31Oct || !isdistanceAvailable ? 0 : distanceValue;
	let value = p_r_s != 1 ? distance : roofRegularDst * 2;
	return value;
};
export const convertToTwoDecimalPlace = (input) => {
	const str = String(input);
	const truncated = str.replace(/^(-?\d+)(\.\d{0,2})?\d*$/, "$1$2");
	return Number(truncated);
};

export const updateDocOnSave = () => {
	if (params.p_u_c) {
		const_var.post_data.building.utility_on_centers = const_var.DistanceArr[params.p_b_t][params.p_r_s];
		const_var.post_data.building.utility_length_list = Object.values(const_var.b_u_D_p_a);
	}
	const_var.post_data.building.distance_on_center = const_var.DistanceArr[params.p_b_t][params.p_r_s];
};

export const prepareLoftDropdown = () => {
	let drop_arr = {};
	let distance = 4;
	var numberofOption = Math.floor((params.p_d - distance) / distance);

	for (let i = 1; i <= numberofOption; i++) {
		drop_arr[convertToTwoDecimalPlace(i * distance) + " Feet"] = convertToTwoDecimalPlace(i * distance);
	}
	const_var.loft_value_array.center = drop_arr;
	let maxDistance = params.p_d - distance;
	if (const_var.selLoftVal.center != 4 && maxDistance < const_var.selLoftVal.center) {
		const_var.selLoftVal.center = 4;
	}
	if (const_var.isLTBuilding && params.add_left_lean) {
		let drop_arr_lean = {};
		let distance_lean = 4;
		var numberofOption_lean = Math.floor((params.lean_p_d - distance_lean) / distance_lean);

		for (let i = 1; i <= numberofOption_lean; i++) {
			drop_arr_lean[convertToTwoDecimalPlace(i * distance_lean) + " Feet"] = convertToTwoDecimalPlace(i * distance_lean);
		}
		const_var.loft_value_array.left = drop_arr_lean;
		let maxDistanceLean = params.lean_p_d - distance_lean;
		if (const_var.selLoftVal.left != 4 && maxDistanceLean < const_var.selLoftVal.left) {
			const_var.selLoftVal.left = 4;
		}
	}
	if (const_var.isLTBuilding && params.add_right_lean) {
		let drop_arr_lean = {};
		let distance_lean = 4;
		var numberofOption_lean = Math.floor((params.leanR_p_d - distance_lean) / distance_lean);

		for (let i = 1; i <= numberofOption_lean; i++) {
			drop_arr_lean[convertToTwoDecimalPlace(i * distance_lean) + " Feet"] = convertToTwoDecimalPlace(i * distance_lean);
		}
		const_var.loft_value_array.right = drop_arr_lean;
		let maxDistanceLean = params.leanR_p_d - distance_lean;
		if (const_var.selLoftVal.right != 4 && maxDistanceLean < const_var.selLoftVal.right) {
			const_var.selLoftVal.right = 4;
		}
	}
	if (const_var.isLTBuilding && params.add_front_lean) {
		let drop_arr_lean = {};
		let distance_lean = 4;
		var numberofOption_lean = Math.floor((params.leanF_p_d - distance_lean) / distance_lean);

		for (let i = 1; i <= numberofOption_lean; i++) {
			drop_arr_lean[convertToTwoDecimalPlace(i * distance_lean) + " Feet"] = convertToTwoDecimalPlace(i * distance_lean);
		}
		const_var.loft_value_array.front = drop_arr_lean;
		let maxDistanceLean = params.leanF_p_d - distance_lean;
		if (const_var.selLoftVal.front != 4 && maxDistanceLean < const_var.selLoftVal.front) {
			const_var.selLoftVal.front = 4;
		}
	}
	if (const_var.isLTBuilding && params.add_back_lean) {
		let drop_arr_lean = {};
		let distance_lean = 4;
		var numberofOption_lean = Math.floor((params.leanB_p_d - distance_lean) / distance_lean);

		for (let i = 1; i <= numberofOption_lean; i++) {
			drop_arr_lean[convertToTwoDecimalPlace(i * distance_lean) + " Feet"] = convertToTwoDecimalPlace(i * distance_lean);
		}
		const_var.loft_value_array.back = drop_arr_lean;
		let maxDistanceLean = params.leanB_p_d - distance_lean;
		if (const_var.selLoftVal.back != 4 && maxDistanceLean < const_var.selLoftVal.back) {
			const_var.selLoftVal.back = 4;
		}
	}
};

export const update26GAUpgradePrice = (str = "center") => {
	if (str == "left" && params.leanStyle.left === "gable" && const_var.lNTBuildingData["updatePriceDataElements"]?.["left"]?.["26 GA Upgrade"]?.["is_edit"]) {
		const_var.lNTBuildingData["updatePriceDataElements"]["left"]["26 GA Upgrade"]["is_edit"] = false;
	} else if (str == "right" && params.leanStyle.right === "gable" && const_var.lNTBuildingData["updatePriceDataElements"]?.["right"]?.["26 GA Upgrade"]?.["is_edit"]) {
		const_var.lNTBuildingData["updatePriceDataElements"]["right"]["26 GA Upgrade"]["is_edit"] = false;
	} else if (str == "front" && params.leanStyle.front === "gable" && const_var.lNTBuildingData["updatePriceDataElements"]?.["front"]?.["26 GA Upgrade"]?.["is_edit"]) {
		const_var.lNTBuildingData["updatePriceDataElements"]["front"]["26 GA Upgrade"]["is_edit"] = false;
	} else if (str == "back" && params.leanStyle.back === "gable" && const_var.lNTBuildingData["updatePriceDataElements"]?.["back"]?.["26 GA Upgrade"]?.["is_edit"]) {
		const_var.lNTBuildingData["updatePriceDataElements"]["back"]["26 GA Upgrade"]["is_edit"] = false;
	} else {
		if (const_var.isLTBuilding) {
			if (const_var.lNTBuildingData?.["updatePriceDataElements"]?.["centerBuilding"]?.["26 GA Upgrade"]?.["is_edit"]) {
				const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]["26 GA Upgrade"]["is_edit"] = false;
			}
		} else {
			if (const_var.UpdatedPriceData?.["elements"]?.["26 GA Upgrade"]?.is_edit) {
				const_var.UpdatedPriceData["elements"]["26 GA Upgrade"]["is_edit"] = false;
			}
		}
	}
};

export const makeSidingOptions = () => {
	setBuildingSidingMaterialOptions();
};
export const num = (v) => {
	const n = Number(v);
	return Number.isFinite(n) ? n : 0;
};
export function getFtPrice(price) {
	const ft = params.p_w + params.p_d;
	return price * ft;
}
export function getSqftPrice(price) {
	const sqft = params.p_w * params.p_d;
	return price * sqft;
}
export function getPercentPrice({ price, percentage_of, post_data, customBase }) {
	const percent = price / 100;
	const building = post_data?.building ?? {};
	const { roof_style_price = 0, grand_total = 0, front_wall_price = 0, back_wall_price = 0, left_wall_price = 0, right_wall_price = 0, height_price = 0 } = building;
	const basePrice = roof_style_price;
	const buildingPrice = grand_total;
	const wallPrice = front_wall_price + back_wall_price + left_wall_price + right_wall_price;
	const heightPrice = height_price;

	if (customBase != null) {
		return num(customBase * percent);
	}
	switch (percentage_of) {
		case PRICE_OF_VALUES.building_amount:
			return num(percent * buildingPrice);
		case PRICE_OF_VALUES.base_price:
			return num(percent * basePrice);
		case PRICE_OF_VALUES.height:
			return num(percent * heightPrice);
		case PRICE_OF_VALUES.wall:
			return num(percent * wallPrice);
	}
}
